import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  IPayment,
  IPaymentData,
  PaymentLiquidationState,
  PaymentMethod,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
import { InvoiceCustomer } from './invoice-customer.model';
import { Liquidation } from './liquidation.model';

export class Payment extends BaseModel<Payment, 'Payment'> implements IPayment {
  static override readonly modelName: AbilitySubjectType = 'Payment';

  @Type(() => Date)
  date!: Date;
  @Type(() => Date)
  authorizationDate?: Date | null;
  @Type(() => Date)
  period!: Date;
  closureNo?: string;
  variableSymbol!: string;
  specificSymbol?: string;
  constantSymbol?: string;
  note?: string;
  externalId?: string;
  paymentData?: IPaymentData;
  paymentMethod!: PaymentMethod;
  intentId?: string | null | undefined;
  @Type(() => Number)
  totalAmount!: number;
  @Type(() => Number)
  representedAmount!: number;
  @Type(() => Number)
  returnedAmount!: number;
  @Type(() => Number)
  liquidatedAmount!: number;
  liquidationState!: PaymentLiquidationState;
  customerId?: string;
  customer?: InvoiceCustomer;
  @Type(() => Liquidation)
  liquidations?: Liquidation[];
  sipoNumber?: string;
  iban?: string;
  bankAccountIban?: string;
  bankTransactionId?: string;
  returnedPaymentId?: string;
  @Type(() => Payment)
  returnedPayment?: Omit<Payment, 'returnedPayment'>;
  totalLiquidableAmount?: number;
  liquidableAmount?: number;
  returnableAmount?: number;
  metadata?: Record<string, unknown>;
}
